<form [formGroup]="formGroup" (submit)="$event.preventDefault()">
  <div
    class="ui-filters-toolbar"
    [class.ui-filters-toolbar--open]="open || alwaysOpen"
    [class.ui-filters-toolbar--dropdown]="asDropdown"
  >
    <button
      *ngIf="asDropdown"
      type="button"
      class="ui-filters-dropdown-toggle"
      (click)="toggleFilters()"
      [attr.aria-expanded]="open"
    >
      <span>{{ dropdownLabel }}</span>
      <i class="bi" [ngClass]="open ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
    </button>
    <div class="ui-filters-fields">
      <ng-content select="[uiFiltersFields]"></ng-content>
      <div
        class="ui-filters-mobile-actions"
        [class.ui-filters-mobile-actions--with-utilities]="alwaysOpen || asDropdown"
      >
        <button
          *ngIf="!alwaysOpen && !asDropdown"
          type="button"
          class="btn btn-secondary"
          (click)="closeFilters()"
        >
          Cerrar
        </button>
        <button
          *ngIf="alwaysOpen"
          type="button"
          class="btn btn-secondary"
          (click)="clear.emit()"
        >
          {{ clearLabel }}
        </button>
        <button
          *ngIf="asDropdown"
          type="button"
          class="btn btn-toolbar-text ui-filters-clear"
          (click)="clear.emit()"
        >
          {{ clearLabel }}
        </button>
        <button
          *ngIf="!alwaysOpen && !asDropdown"
          type="button"
          class="btn btn-primary"
          (click)="apply.emit()"
        >
          Aplicar filtros
        </button>
        <div class="ui-filters-panel-utilities">
          <ng-content select="[uiFiltersPanelActions]"></ng-content>
        </div>
      </div>
    </div>
    <div class="ui-filters-desktop-actions" *ngIf="!hideDesktopActions">
      <button
        type="button"
        class="btn btn-toolbar-text"
        [class.ui-filters-desktop-clear]="asDropdown"
        (click)="clear.emit()"
      >
        {{ clearLabel }}
      </button>
      <ng-content select="[uiFiltersDesktopActions]"></ng-content>
    </div>
  </div>

  <div class="ui-filters-compact d-lg-none" *ngIf="!alwaysOpen && !asDropdown">
    <div class="ui-filters-compact-actions">
      <button
        *ngIf="!alwaysOpen"
        type="button"
        class="btn btn-compact-link"
        (click)="toggleFilters()"
      >
        <span>{{ open ? 'Ocultar filtros' : moreFiltersLabel }}</span>
        <i class="bi" [ngClass]="open ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </button>
      <button type="button" class="btn btn-compact-link" (click)="clear.emit()">
        {{ clearLabel }}
      </button>
      <ng-content select="[uiFiltersMobileActions]"></ng-content>
    </div>
  </div>
</form>
